module.exports = "/fonts/Metropolis-Regular.otf?f7b5e589f88206b4bd5cb1408c5362e6";